// import { AnalyticHub } from './analytic.js'
import { ENV } from './proj_env.js'
import { User } from './user.js'
import { CommonUtility } from './utility.js'
import { md5 } from 'js-md5'

export class API {
  static REQUEST_STATUS_NONE = 0
  static REQUEST_STATUS_LOADING = 1
  static REQUEST_STATUS_SCUCESS = 2
  static REQUEST_STATUS_FAILED = -1

  static async post(url, inputParams, tiemout = 30000, credentials = false) {
    if (!url) throw this.REQUEST_STATUS_FAILED;
    return await new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      // if (credentials) {
      //   xhr.withCredentials = true;
      // }
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.ontimeout = () => {
        reject(this.REQUEST_STATUS_FAILED);
      };
      xhr.onerror = () => {
        reject(this.REQUEST_STATUS_FAILED);
      };
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              var jsonResponse = JSON.parse(xhr.responseText);
              resolve(jsonResponse);
            } catch (e) {
              reject(this.REQUEST_STATUS_FAILED);
            }
          } else {
            reject(this.REQUEST_STATUS_FAILED);
          }
        }
      };

      const params = commonParams();
      if (inputParams) {
        Object.keys(inputParams).forEach(function (key) {
          params[key] = inputParams[key];
        });
      }
      let keys = [];
      Object.keys(params).forEach(function (key) {
        keys.push(key);
      });

      keys = keys.sort();
      const signPairs = [];
      const bodyPairs = [];
      for (const key of keys) {
        bodyPairs.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        );
        signPairs.push(`${key}=${params[key]}`);
      }
      let sign = signPairs.join("&");
      sign = md5(`${sign}FtA50esxi`);
      bodyPairs.push(`sign=${sign}`);
      const body = bodyPairs.join(`&`);
      xhr.send(body);
    });
  }

  static async upload(url, inputParams, progressListener, ...files) {
    if (!url) throw this.REQUEST_STATUS_FAILED
    try {
      const formData = new FormData()
      let params = commonParams()
      Object.keys(params).forEach(function (key) {
        formData.append(key, params[key])
      })
      if (inputParams) {
        Object.keys(inputParams).forEach(function (key) {
          formData.append(key, inputParams[key])
        })
      }
      if (files) {
        for (let file of files) {
          formData.append(file.name, file.file)
        }
      }
      let resp = await new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest()
        if (progressListener) {
          xhr.upload.addEventListener(
            'progress',
            (d) => {
              if (d.lengthComputable) {
                let uploadPercent = d.loaded / d.total
                progressListener(uploadPercent)
              }
            },
            false
          )
        }
        xhr.onload = () => {
          try {
            let resp = JSON.parse(xhr.response)
            resolve(resp)
          } catch (_) {
            reject(this.REQUEST_STATUS_FAILED)
          }
        }
        xhr.onerror = () => {
          reject(this.REQUEST_STATUS_FAILED)
        }
        xhr.open('POST', url, true)
        xhr.send(formData)
      })
      return resp
    } catch (e) {
      throw this.REQUEST_STATUS_FAILED
    }
  }

  /// 获取用户数据
  static async loadUserInfo() {
    return await API.post(`${ENV.currentConfig.apiHost}/user/getinfo`)
  }

  /// 获取config配置数据
  static async loadConfigInfo() {
    return await API.post(`${ENV.currentConfig.apiHost}/setting/infos`)
  }

  /// google注册
  static async googleUserRegister({ email, googleIdToken, googleAccessToken }) {
    let params = {
      email: email,
    }
    if (googleIdToken) {
      params['googleIdToken'] = googleIdToken
    } else if (googleAccessToken) {
      params['googleAccessToken'] = googleAccessToken
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/register_google`, params)
  }

  /// 登录
  static async userLogin({ email, password, code, googleIdToken, googleAccessToken }) {
    let params = {
      email: email,
    }
    if (password) {
      params['password'] = password
    }
    if (code) {
      params['code'] = code
    }
    if (googleIdToken) {
      params['googleIdToken'] = googleIdToken
    }
    if (googleAccessToken) {
      params['googleAccessToken'] = googleAccessToken
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/loginin`, params, 30000, true)
  }

  /// 邮箱注册不需要验证码
  static async userRegister({ email, password, referralKey, affiliateKey }) {
    let params = {
      email: email,
      password: password,
    }
    if (referralKey) {
      params['referralKey'] = referralKey
    }
    if (affiliateKey) {
      params['affiliateKey'] = affiliateKey
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/register_email_new`, params, 30000, true)
  }

  /// 注册发送验证码
  static async userSendRegisterCode({ email }) {
    let params = {
      email: email,
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/sendregistercode`, params)
  }

  /// 邮箱验证码注册
  static async userRegisterVerify({ email, password, verifyCode, referralKey }) {
    let params = {
      email: email,
      password: password,
      code: verifyCode,
    }
    if (referralKey) {
      params['referralKey'] = referralKey
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/register_email`, params, 30000, true)
  }

  /// 重置密码
  static async resetPassword({ email, code, newPassword }) {
    let params = {
      email: email,
      code: code,
      newPassword: newPassword,
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/resetPassword`,params)
  }

  /// 重置密码验证码获取
  static async sendForgotEmailCode({ email }) {
    let params = {
      email: email,
    }
    return await API.post(`${ENV.currentConfig.apiHost}/user/sendforgotcode`, params)
  }

  /// 用户设备注册
  static async userDeviceOpen() {
    return await API.post(`${ENV.currentConfig.apiHost}/user/open`)
  }
}

function commonParams() {
  var lang = navigator.language || navigator.userLanguage
  var country = lang.split('-')[0]
  let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  let timezoneOfset = Math.abs(new Date().getTimezoneOffset() * 60)
  let timezoneStr = `${timezone} ${timezoneOfset}`
  let params = {
    packageName: ENV.currentConfig.packageName,
    appVersion: ENV.currentConfig.version,
    language: lang,
    countryCode: country,
    region: country,
    deviceType: navigator.userAgent,
    timestamp: parseInt(new Date().valueOf() / 1000),
    udid: CommonUtility.getUuid(),
    timezone: timezoneStr,
    platform: 'web',
  }
  params['token'] = User.getInstance.token.value
  return params
}

function timeoutFetch(ms, promise) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      // AnalyticHub.getInstance.log('server_delay')
      reject(new Error('TIMEOUT'))
    }, ms)
    promise
      .then((value) => {
        clearTimeout(timer)
        resolve(value)
      })
      .catch((reason) => {
        clearTimeout(timer)
        reject(reason)
      })
  })
}
